import { Tractor, Hammer, Sun, Sprout, Truck } from "lucide-react";

const steps = [
  { icon: Tractor, label: "Site preparation", note: "Fencing, access tracks, drainage" },
  { icon: Truck, label: "Deliveries", note: "Panels & components by HGV" },
  { icon: Hammer, label: "Installation", note: "Steel piles & frames, then panels" },
  { icon: Sun, label: "Energisation", note: "Cabling, inverters, grid connection" },
  { icon: Sprout, label: "Restoration", note: "Re-seeding, hedgerow planting" },
];

export default function ConstructionTimeline() {
  return (
    <section className="bg-[#F2EFE8] border-y border-[#E0DCD3]" data-testid="construction-timeline-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-20 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-12">
          <div className="lg:col-span-5 reveal">
            <p className="overline mb-4">Construction</p>
            <h2 className="font-serif-display text-3xl lg:text-4xl tracking-tight">
              18 – 24 months of works, then decades of quiet operation.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 reveal">
            <p className="text-[15px] leading-relaxed text-[#2A2B2A]/85">
              A Community Liaison Officer will work with residents throughout
              construction, keeping people updated and handling queries. A
              dedicated Traffic Management Plan will be in place.
            </p>
          </div>
        </div>

        <div className="relative reveal">
          {/* connecting line */}
          <div className="hidden md:block absolute left-0 right-0 top-[52px] h-px bg-[#CBB99A]" />

          <ol className="grid grid-cols-2 md:grid-cols-5 gap-y-10 gap-x-6 relative">
            {steps.map((s, i) => {
              const Ic = s.icon;
              return (
                <li key={i} className="flex flex-col items-start" data-testid={`timeline-step-${i}`}>
                  <div className="relative">
                    <div className="inline-flex h-[60px] w-[60px] items-center justify-center rounded-sm bg-white border border-[#E0DCD3]">
                      <Ic className="h-5 w-5 text-[#3A4B3A]" strokeWidth={1.7} />
                    </div>
                  </div>
                  <div className="mt-5">
                    <div className="text-[11px] tracking-[0.18em] uppercase font-semibold text-[#CBA365]">
                      Step {String(i + 1).padStart(2, "0")}
                    </div>
                    <div className="font-serif-display text-lg mt-1 tracking-tight">{s.label}</div>
                    <div className="text-[13px] text-[#63635E] mt-1">{s.note}</div>
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}
